import session from '../../auth_api/session'

const URL = process.env.VUE_APP_API_URL
const appURL = URL + 'gis_gmp/api/'

export default {
  namespaced: true,
  state: {
    listChargeForPreparation: { 'results': [] }
  },
  mutations: {
    setListChargeForPreparation (state, payload) {
      state.listChargeForPreparation = payload
    }
  },
  actions: {
    fetchListChargeForPreparation ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'fetchListChargeForPreparation'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = {}
        if ((0 + payload.pageId) > 1) {
          params['page'] = payload.pageId
        }
        let _url = appURL + 'charge-for-preparation/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setListChargeForPreparation', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    preparationCharges ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'preparationCharges'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        const data = new FormData()
        data.append('pageId', payload.pageId)
        data.append('ides', payload.ides)
        let _url = appURL + 'charge-for-preparation/preparations/'
        session({ method: 'put', url: _url, data: data, headers: { 'Content-Type': 'application/json' } })
          .then(response => {
            commit('setListChargeForPreparation', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }

  },
  getters: {
    listChargeForPreparation (state) {
      return state.listChargeForPreparation
    }

  }
}
